import React from 'react';
import { compose } from 'ramda';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from './engineTop.js';
import Slide, { SlideItem, ButtonSlide } from '@synergycms_core/components/generic/Slide';
import { RichText, Link } from '@synergycms_core/components/generic';
import MyReservation from './MyReservation';

class EngineTop extends React.Component {
  static displayName = 'EngineTop';
  constructor(props) {
    super(props);
    this.cx = props.theme.bind();
  }

  
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { 
      myBookingUrl, 
      linksList, 
      showModalView
    } = config;

    return (
        <div className={theme.computedInnerStyle}>
          <div className={[classes.moreOptionsContainer, this.cx({ multiSlide: linksList.length > 1, monoSlide: linksList.length === 1 })].join(' ')}>
            <div className={classes.travelOptions}>
              <div className={classes.travelOptionsContainer}>
                <div className={classes.travelOptionsContent}>
                  <RichText
                    text={'_%hotel%_'}
                    ucFirst={true}
                    translate={true}
                    innerStyle={classes.travelOptionsText}
                    icon={{ unicodeContent: 'e14d', innerStyle: classes.travelOptionsIconGold }}
                  />
                </div>
                <div className={[classes.slideButtonContainer, this.cx({ shortedSlide: myBookingUrl })].join(' ')}>
                  <Slide slideType={"multi"} propagateSelectedKey={this.propagateSelectedPhoto} showModalView={showModalView} >
                    {linksList.map((link) =>
                      <SlideItem key={link.text} contentKey={link.text}>
                          <div key={link.text} className={classes.travelOptionsContentFly}>
                            <Link
                              richText={{
                                text: link.text,
                                icon: { unicodeContent: link.icon, innerStyle: classes.travelOptionsIconSlide },
                                ucFirst: true,
                                translate: true
                              }}
                              innerStyle={classes.travelOptionsTextFly}
                              href={link.url}
                              target={'_blank'}
                            />
                          </div>
                      </SlideItem>
                    )}
                    <div className={classes.wrapperButtons}>
                      <ButtonSlide
                        icon={{
                          unicodeContent: 'e0b4',
                          innerStyle: ['size13']
                        }}
                        direction={'next'}
                        innerStyle={classes.topButton}
                      />
                      <ButtonSlide
                        icon={{
                          unicodeContent: 'e0b3',
                          innerStyle: ['size13']
                        }}
                        direction={'prev'}
                      />
                    </div>
                  </Slide>
                </div>
              </div>
            </div>
            {myBookingUrl && <MyReservation myBookingUrl={myBookingUrl} />}
          </div>
        </div>
      
    );
  }
}

export default compose(
  PropertyManager([
    'showModalView',
    'myBookingUrl',
    'linksList'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(EngineTop);
